import { makeStyles } from '@mui/styles';

import { globalTheme as theme } from '@styles';

export const useStyles = makeStyles(() => ({
  backdrop: {
    color: 'rgba(40, 51, 62, 0.75)',
    zIndex: theme.zIndex.drawer + 1,
  },

  offRampCard: {
    padding: '24px',
    borderRadius: '16px !important',
    width: '26rem',
  },

  slideCard: {
    padding: '24px',
    zIndex: 99,
    position: 'absolute',
    bottom: 0,
    // right: 0,
    height: 'auto',
    minHeight: '400px',
    width: '100%',
    borderRadius: '0 !important',
    [theme.breakpoints.up('md')]: {
      height: '100%',
      top: 0,
      right: 0,
      width: '23rem',
      minHeight: '400px',
    },
  },
}));
